const _showLogPatches = false

export const logPatches = (component, type, patches, action) => {

  if (!patches.length || !_showLogPatches) return;

  console.groupCollapsed(`🔄 ${component}: State Change via: ${type}`);

  console.log('▶️ action', action);

  patches.forEach(p => {
    console.log(
      `▶️ ${p.op.toUpperCase()} at ${p.path.join(".")}:`,
      p.value
    );
  });
  console.groupEnd()

};

export const logBatch = (batch, dataToUpdate) => {
  // const batches = []
  // _.forEach(batch?._mutations, (m) => {
  //   if (m?.key?.path?.segments) {
  //     batches.push(m?.key?.path?.segments)
  //   }
  // })

  _.forEach(batch?._mutations, (m) => {
    const segments = m?.key?.path?.segments;
    if (segments) {
      const path = segments.join('/');
      console.log('path', path);
    }
  });

  console.log('dataToUpdate', dataToUpdate)
}